import type { CameraAdjustment } from 'shared/interfaces/Types';

abstract class CameraAnimation {
  constructor(private readonly endCallback?: () => void) {}

  abstract update(): CameraAdjustment | undefined;

  getAdjustment() {
    const adjustment = this.update();
    if (adjustment === undefined && this.endCallback != undefined) {
      this.endCallback();
    }
    return adjustment;
  }
}

export default CameraAnimation;
